<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><i>For all my students—past, present and future. May they always remember to learn from their mistakes and never forget the hidden strength of forgiveness.</i></p>
<p class="ded1"><i>P.Z.</i></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?3ff9a3f8